














































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import YcColorPicker from "@/components/color-picker/index.js";
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import discountDialog from '../components/discountDialog.vue';
import PopUnifiedDiscountSettingsDialog from '@/views/wheelOfFortune/components/PopUnifiedDiscountSettingsDialog.vue';
import { isEnablePopUnifiedDiscountCode } from '@/utils/experiment';
import { getCompanyInfo } from '@/model/CompanyInfo';

enum permissionType {EDIT = 'edit', CHECK = 'check'}

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "yc-color-picker": YcColorPicker,
    discountDialog: discountDialog,
    PopUnifiedDiscountSettingsDialog,
  },
})
export default class wheelOfFortuneSetting extends Vue {
  @Prop(Array)
  tableData!:FormWheelSliceVO[];

  @Prop(Object)
  formData!: TFormSaveDetailRequest;


  public permission = '';
  public permissionType = permissionType;

  showDiscountDialog = false;
  editDiscountIndex = -1;
  discountData = {};

  get customDiscountEnabled() {
    return getCompanyInfo().customDiscountOpen === true;
  }

  get isShopify() {
    return sessionStorage.getItem('isShopify') === '1';
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1' || this.customDiscountEnabled;
  }

  get useUnifiedDiscountSettings() {
    return isEnablePopUnifiedDiscountCode();
  }

  get discountTypeOptions(): Array<{name: string, value: string}> {
    const options = [{ name: '固定折扣码', value: 'guding' }];
    if (this.customDiscountEnabled) {
      options.push({ name: '自定义优惠券', value: 'customer' });
    }
    // 动态折扣码依赖 Shopify Price Rule，非 Shopify 店铺不展示（对齐 textEndNew.vue discountTypeOptions）
    if (this.isShopify) {
      options.push({ name: '动态折扣码', value: 'dongtai' });
    }
    return options;
  }

  /** 本次弹窗正在编辑的折扣类型：dongtai / customer。用于决定弹窗形态与保存后回写的类型 */
  pendingDiscountType = '';

  /** 自定义优惠券走「规则ID + 备用码」表单，其余走 Shopify 动态折扣规则表单 */
  get currentSourceType() {
    return this.pendingDiscountType === 'customer' ? 'CUSTOMER_SYSTEM' : '';
  }

  /**
   * 统一折扣码弹窗（PopUnifiedDiscountSettingsDialog）只服务 Shopify 折扣码规则，
   * 未声明 sourceType，自定义优惠券必须回落到 discountDialog。
   */
  get useUnifiedDialogForCurrent() {
    return this.useUnifiedDiscountSettings && this.pendingDiscountType !== 'customer';
  }


  changeDiscountType(row:any, index: number) {
    if (row.discountType === 'guding') {
      row.discount = null;
      this.tableData[index].discount = null;
      this.pendingDiscountType = '';
      this.showDiscountDialog = false;
      this.discountData = {};
      this.editDiscountIndex = -1;
    } else {
      // 先记住本次选择的类型（dongtai / customer），保存成功后再回写，取消则保持 guding
      this.pendingDiscountType = row.discountType;
      this.editDiscountIndex = index;
      this.discountData = JSON.parse(JSON.stringify(this.tableData?.[this.editDiscountIndex]?.discount||{
      valueType: 2,
      minBuyRequireType: 0}));
      this.openDiscountDialog();
    }
    row.discountType = 'guding';
    this.tableData[index].discountType = 'guding';
  }
  openDiscountDialog() {
    this.showDiscountDialog = false;
    this.$nextTick(() => {
      this.showDiscountDialog = true;
    });
  }
  showDiscountDialogHandle(index: number) {
    this.editDiscountIndex = index;
    // 二次编辑：沿用该行已有类型，保证自定义优惠券仍打开「规则ID + 备用码」表单
    this.pendingDiscountType = this.tableData?.[index]?.discountType || 'dongtai';
    this.discountData = JSON.parse(JSON.stringify(this.tableData?.[this.editDiscountIndex]?.discount||{
      valueType: 2,
      minBuyRequireType: 0}));
    this.openDiscountDialog();
  }
  saveDiscount(discount:any) {
    if (this.editDiscountIndex < 0) {
      this.resetDiscountDialogState();
      return;
    }
    const savedType = this.pendingDiscountType === 'customer' ? 'customer' : 'dongtai';
    const payload = discount || {};
    if (savedType === 'customer') {
      // 显式标记来源，后端 extractor 据此写 t_common_discount_rule_map.source_type
      payload.sourceType = 'CUSTOMER_SYSTEM';
    } else {
      // 由客户系统切回动态折扣时清理残留，避免后端把 Shopify 动态折扣误判成自建折扣
      delete payload.sourceType;
      delete payload.customerRuleId;
    }
    this.tableData[this.editDiscountIndex].couponCode = '';
    this.tableData[this.editDiscountIndex].discount = payload;
    this.tableData[this.editDiscountIndex].discountType = savedType;
    this.resetDiscountDialogState();
  }
  closeDiscount() {
    this.resetDiscountDialogState();
  }
  private resetDiscountDialogState() {
    this.showDiscountDialog = false;
    this.discountData = {};
    this.editDiscountIndex = -1;
    this.pendingDiscountType = '';
  }


  async created(): Promise<void> {
    if(this.$route.path.match(new RegExp('^/wheel_of_fortune/check/[^/]*$'))) {
      this.permission = permissionType.CHECK;
    }
  }

  /** 客户系统（自建）折扣码：couponId 形如 CUST_xxx，或直接带 customerRuleId / sourceType */
  private isCustomerDiscount(discount: any): boolean {
    if (!discount) {
      return false;
    }
    return discount.sourceType === 'CUSTOMER_SYSTEM'
      || !!discount.customerRuleId
      || (typeof discount.couponId === 'string' && discount.couponId.startsWith('CUST_'));
  }

  async mounted(): Promise<void> {
    for (let i = 0; i < this.tableData?.length; i++) {
      const data = this.tableData?.[i];
      // if (!data.discountType) {
        if (!!data.couponCode || !data.discount) {
          data.discountType = 'guding';
        } else if (this.isCustomerDiscount(data.discount)) {
          data.discountType = 'customer';
        } else {
          data.discountType = 'dongtai';
        }
      // }
    }
  }


  /**
   * 下一步
   */
   nextStep() {
    this.$emit('nextStep')
  }

  /**
   * 上一步
   */
  backStep() {
    this.$emit('backStep')
  }

  /**
   * 取消
   */
  cancel() {
    this.$emit('cancel')
  }

}
